import React from "react";
import { motion } from "framer-motion";
import "./OurBusiness.css";
import { Link } from "react-router-dom";

const OurBusiness = () => {
  const cardData = [

    {
      imageSrc: "./assets/img/ourBusiness/Polypropylene-Product.jpg",
      title: "Polypropylene",
      description:
        "Explore our versatile Polypropylene products designed for various industries and applications.",
      link: "business/Polypropylene",
    },
    {
      imageSrc: "./assets/img/ourBusiness/Construction-Product.jpg",
      title: "Construction",
      description:
        "Explore our advanced construction products delivering quality, durability, and performance across industries.",
      link: "business/Construction",
    },
    {
      imageSrc: "./assets/img/ourBusiness/Tyre-Product.jpg",
      title: "Tyres",
      description:
        "",
      link: "business/Tyre",
    },
    {
      imageSrc: "./assets/img/ourBusiness/pharma.jpg",
      title: "Chemical",
      description:
        "At Dohrnii Exim Pvt Ltd, we specialize in providing high-quality Active Pharmaceutical Ingredients (API) and Excipients to pharmaceutical manufacturers worldwide. Our APIs are sourced from reputable suppliers, ensuring that every ingredient meets the highest standards of purity and effectiveness.",
      link: "business/api-excipients",
    },
    {
      imageSrc: "./assets/img/ourBusiness/mine.jpg",
      title: "Metals & Mineral Resources",
      description:
        "At Dohrnii Exim Pvt Ltd, we supply a diverse range of Metals and Mineral Resources that are vital to industries worldwide. From iron, steel, and copper to precious metals like gold and silver, our materials are sourced from reputable mining operations and are available in bulk quantities to meet your production needs.",
      link: "business/metals-minerals",
    },
    // {
    //   imageSrc: "./assets/img/ourBusiness/chemicals.jpg",
    //   title: "Industrial Chemicals",
    //   description:
    //     "We offer a comprehensive range of Industrial Chemicals for various sectors, including manufacturing, agriculture, automotive, and textiles...",
    //   link: "#",
    // },

    {
      imageSrc: "./assets/img/ourBusiness/agro.jpg",
      title: "Agricultural Commodities",
      description:
        "We supply essential Agricultural Commodities that support global food security and industrial needs. From grains like wheat, corn, and rice, to vegetables, fruits, and livestock products, we are dedicated to providing high-quality products that meet the diverse demands of the agricultural industry.",
      link: "business/agricultural-commodities",
    },
    {
      imageSrc: "./assets/img/ourBusiness/oil.jpg",
      title: "Edible & Essential Oils",
      description:
        "We offer a diverse selection of Edible Oils and Essential Oils for both food and wellness industries. Our edible oils include sunflower oil, olive oil, palm oil, and soybean oil, all sourced from trusted suppliers to ensure top-quality and consistency in every batch.",
      link: "business/edible-essential-oils",
    },
    // {
    //   imageSrc: "./assets/img/ourBusiness/mall.jpg",
    //   title: "Cosmetics",
    //   description:
    //     "As a leading supplier of Fast-Moving Consumer Goods (FMCG), we provide a wide range of everyday products that consumers rely on. From food and beverages to personal care items, cleaning products, and over-the-counter medicines, our FMCG offerings cater to markets worldwide.",
    //   link: "business/fmcg",
    // },
    {
      imageSrc: "./assets/img/ourBusiness/palm.jpg",
      title: "EcoPalm Products",
      description:
        "Our Palmware Products offer an eco-friendly alternative to traditional plastic items. Made from the leaves of the areca palm, these biodegradable products include plates, trays, cups, and cutlery—perfect for catering, events, and everyday use. Palmware is a renewable resource that helps reduce plastic waste and supports sustainable practices.",
      link: "business/ecopalm-products",
    },
  ];

  return (
    <section className="ourBusiness">
      <div className="container pb-5 pt-5">
        <motion.div
          className="text-center mb-5"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {/* <h2 className="c-section-title">Our Products</h2> */}
          <h2 className="c-section-title">Products</h2>
        </motion.div>
        <div className="row">
          {cardData.map((card, index) => (
            <motion.div
              key={index}
              className="col-md-4 mb-3"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <Link
                to={card.link}
                className="recent-work card border-0 shadow-lg overflow-hidden"
              >
                <img
                  src={card.imageSrc}
                  alt="Card image"
                  className="recent-work-img card-img"
                  loading="lazy"
                />
                <div className="recent-work-vertical card-img-overlay d-flex align-items-end">
                  <motion.div
                    className="recent-work-content text-start mb-3 ml-3 text-dark"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.5 }}
                  >
                    <h3 className="card-title light-300">{card.title}</h3>
                    {/* <p className="card-text">{card.description}</p> */}
                  </motion.div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurBusiness;
